module.exports = __webpack_public_path__ + "static/media/emptyProducts.123d162b.svg";